/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingSampleDataControllerSeedMutationRequest, BidLevelingSampleDataControllerSeedMutationResponse, BidLevelingSampleDataControllerSeed400, BidLevelingSampleDataControllerSeed401, BidLevelingSampleDataControllerSeed403 } from "../../models/bidsController/BidLevelingSampleDataControllerSeed";

function getBidLevelingSampleDataControllerSeedUrl() {
  const res = { method: 'POST', url: `/api/v1/bid-leveling-sample-data` as const }  
  return res
}

/**
 * @description Does nothing when the project already has trades.
 * @summary Load the sample trades into a project (not available in production)
 * {@link /api/v1/bid-leveling-sample-data}
 */
export async function bidLevelingSampleDataControllerSeed(data?: BidLevelingSampleDataControllerSeedMutationRequest, config: Partial<RequestConfig<BidLevelingSampleDataControllerSeedMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<BidLevelingSampleDataControllerSeedMutationResponse, ResponseErrorConfig<BidLevelingSampleDataControllerSeed400 | BidLevelingSampleDataControllerSeed401 | BidLevelingSampleDataControllerSeed403>, BidLevelingSampleDataControllerSeedMutationRequest>({ method : "POST", url : getBidLevelingSampleDataControllerSeedUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}